export type NodeType = 'actor' | 'resource' | 'artifact' | 'event';

export type ActorSubtype = 'person' | 'team' | 'role' | 'org' | 'external_party';
export type ResourceSubtype = 'software' | 'tool' | 'channel';
export type ArtifactSubtype = 'document' | 'contract' | 'ticket' | 'dataset' | 'invoice' | 'brief' | 'report';
export type EventSubtype = 'event';

export type NodeSubtype = ActorSubtype | ResourceSubtype | ArtifactSubtype | EventSubtype;

export interface ProcessNode {
  id: string;
  type: NodeType;
  subtype?: NodeSubtype;
  label: string;
  createdBy?: string;
  updatedAt?: number;
}

export type CanvasNodeType = NodeType;

export interface CanvasNode {
  id: string;
  x: number;
  y: number;
  label: string;
  type: NodeType;
  subtype?: NodeSubtype;
  initials?: string;
  createdBy?: string;
  updatedAt?: number;
}

export function resolveNodeSubtype(type: NodeType, subtype?: NodeSubtype): NodeSubtype {
  if (type === 'event') return 'event';
  if (subtype) return subtype;
  switch (type) {
    case 'actor':
      return 'person';
    case 'resource':
      return 'tool';
    case 'artifact':
      return 'document';
    default:
      return 'event';
  }
}

export function canvasNodeToProcessNode(node: CanvasNode): ProcessNode {
  return {
    id: node.id,
    type: node.type,
    ...(node.type === 'event' ? {} : { subtype: resolveNodeSubtype(node.type, node.subtype) }),
    label: node.label,
    createdBy: node.createdBy,
    updatedAt: node.updatedAt,
  };
}

export function processNodeToCanvasNode(node: ProcessNode): CanvasNode {
  return {
    id: node.id,
    x: 0,
    y: 0,
    label: node.label,
    type: node.type,
    ...(node.type === 'event' ? {} : { subtype: resolveNodeSubtype(node.type, node.subtype) }),
    createdBy: node.createdBy,
    updatedAt: node.updatedAt,
  };
}
